module.exports = __webpack_public_path__ + "img/subBanner15.1b91eaf4.png";